import { useTranslation } from 'react-i18next'
import useSWR from 'swr'

import { Link } from 'react-router'

import { PageHeader } from '@/components/ds'
import { Loading } from '@/components/Loading'
import { Button } from '@/components/ui/button'
import { apiFetcher } from '@/data/fetcher'
import { UploadExpenseForm } from '@/forms/UploadExpenseForm/UploadExpenseForm'
import { Settings } from '@/interfaces/Settings'
import { useSetPageHeader } from '@/contexts/PageHeaderContext'

export default function ExpenseUploadPage() {
  const { t } = useTranslation(undefined, {
    keyPrefix: 'expense',
  })
  const { data: settings, isLoading } = useSWR<Settings>(
    `/api/v2/settings`,
    apiFetcher,
  )
  const title = `${t('upload.title')}`

  useSetPageHeader({
    breadcrumbs: [
      {
        href: '/expenses',
        children: t('list.title'),
      },
      {
        href: '/expense/upload',
        children: title,
      },
    ],
  })

  if (isLoading) {
    return <Loading />
  }

  return (
    <>
      <title>{title}</title>

      <div className="mx-auto w-full max-w-2xl">
        <PageHeader
          title={title}
          description="Nahrajte fakturu nebo účtenku, údaje vyplníme za vás."
          actions={
            <Button variant="outline" asChild>
              <Link to="/expense/new">Zadat ručně</Link>
            </Button>
          }
        />
        <UploadExpenseForm />
      </div>
    </>
  )
}
